module.exports = "/packs/course-marketing-first-bf4c82d72dff7858512fc567e71acc48.png";